// @flow
import React, { Component } from 'react';
import { Row, Col, Container } from 'reactstrap';
import classNames from 'classnames';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import './Success.scss';
import logo from './icons8-car-service-50.png';

// Utils
import { formatTime } from 'utils/date';
import { TRANSPORTATION } from 'constants/transportation';

const { VALET, VALETLOANER } = TRANSPORTATION;

const ns = 'success';
const md = 'middle';

type Props = {
  intl: IntlShape,
  date: Object,
  externalValet: string,
  transportationOption: string
};

type State = {
  animationFlag: boolean
};

class Success extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      animationFlag: false
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      animationFlag: true
    });
  }

  getFormattedBody = () => {
    const { date, intl, externalValet, transportationOption } = this.props;
    const isValet =
      transportationOption === VALETLOANER || transportationOption === VALET;
    if (externalValet && isValet) {
      return (
        <React.Fragment>
          <Col xs={12} className={`${ns}__${md}--message`}>
            {intl.formatMessage({
              id: 'c8.confirmation.the.dealership.will.contact.you',
              defaultMessage:
                'The dealership will contact you with what to expect next.'
            })}
          </Col>
          <Col xs={12} className={`${ns}__${md}--pick-up-message`}>
            {intl.formatMessage({
              id: 'c8.confirmation.pick.up.date.and.time',
              defaultMessage: 'Pick up date & time'
            })}
          </Col>
          <Col xs={12} className={`${ns}__${md}--inline-date-and-time`}>
            {intl.formatDate(date, {
              weekday: 'short',
              month: 'short',
              day: 'numeric'
            })}{' '}
            {formatTime(date, intl, false, false)}
          </Col>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Col xs={12} className={`${ns}__${md}--date`}>
            {intl.formatDate(date, {
              weekday: 'short',
              month: 'short',
              day: 'numeric'
            })}
          </Col>
          <Col xs={12} className={`${ns}__${md}--time`}>
            {formatTime(date, intl, false, false)}
          </Col>
        </React.Fragment>
      );
    }
  };

  render() {
    const classProps = classNames({
      [`${ns}__${md}`]: true,
      'appearing-element': true,
      'animation-active': this.state.animationFlag
    });
    const { intl } = this.props;
    return (
      <Container className="success">
        <Row className={classProps}>
          <Col xs={12}>
            <img src={logo} alt="" />
          </Col>
          <Col xs={12}>
            <h1 className={`${ns}__${md}--title`}>
              {intl.formatMessage({ id: 'c8.confirmation.success' })}
            </h1>
          </Col>

          <Col xs={12} className={`${ns}__${md}--message`}>
            {intl.formatMessage({
              id: 'c8.confirmation.we.will.send.you.an.email.confirmation'
            })}
          </Col>
          {this.getFormattedBody()}
        </Row>
      </Container>
    );
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/Success/Success.js